{
  "name": "tizimapp",
  "version": "1.0.124",
  "main": "index.ts",
  "scripts": {
    "eas-build-pre-install": "npm install -g npm@11",
    "start": "expo start --dev-client",
    "android": "expo run:android",
    "ios": "expo run:ios",
    "web": "expo start --web",
    "lint": "eslint .",
    "update-version": "node scripts/update-version.js",
    "version:patch": "npm version patch --no-git-tag-version && react-native-version --never-amend && npx expo prebuild --clean",
    "version:minor": "npm version minor --no-git-tag-version && react-native-version --never-amend && npx expo prebuild --clean",
    "version:major": "npm version major --no-git-tag-version && react-native-version --never-amend && npx expo prebuild --clean",
    "version:build": "react-native-version --never-amend --increment-build && npx expo prebuild --clean",
    "version:sync": "react-native-version --never-amend && npx expo prebuild --clean",
    "test:versioning": "node scripts/test-versioning.js",
    "check-git": "node scripts/deploy-check.js",
    "deploy-prepare": "node scripts/deploy-with-version.js",
    "deploy-prepare-only": "node scripts/deploy-prepare-only.js",
    "deploy": "npm run deploy-prepare && firebase deploy --only hosting:dev",
    "deploy:hotel": "npm run deploy-prepare && firebase deploy --only hosting:hotel",
    "deploy:sto": "npm run deploy-prepare && firebase deploy --only hosting:sto",
    "support": "cd maestro && cd support && maestro test all.yaml",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build",
    "build:ios": "eas build --platform ios --profile production",
    "build:ios:preview": "eas build --platform ios --profile preview",
    "submit:ios": "eas submit --platform ios --latest",
    "build-and-submit:ios": "eas build --platform ios --profile production --auto-submit --non-interactive",
    "build-and-submit:ios:testflight": "eas-cli@latest build --platform ios --profile testflight --auto-submit --non-interactive",
    "build-and-submit:android": "eas build --platform android --profile production --auto-submit --non-interactive",
    "update:preview": "node scripts/publish-update.js --channel preview",
    "update:testflight": "node scripts/publish-update.js --channel testflight",
    "update:production": "node scripts/publish-update.js --channel production",
    "update:custom": "node scripts/publish-update.js",
    "postversion": "react-native-version && npx expo prebuild"
  },
  "dependencies": {
    "@expo/metro-runtime": "~55.0.6",
    "@hookform/resolvers": "^5.2.1",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-firebase/app": "^23.4.0",
    "@react-native-firebase/auth": "^23.4.0",
    "@react-native-firebase/firestore": "^23.4.0",
    "@react-native-firebase/functions": "^23.4.0",
    "@react-native-firebase/messaging": "^23.4.0",
    "@react-native-firebase/storage": "^23.4.0",
    "@react-navigation/drawer": "^7.8.1",
    "@react-navigation/elements": "^2.9.5",
    "@react-navigation/native": "^7.1.28",
    "@react-navigation/native-stack": "^7.13.0",
    "@react-navigation/stack": "^7.7.2",
    "@reduxjs/toolkit": "^2.9.0",
    "@types/xlsx": "^0.0.36",
    "date-fns": "^4.1.0",
    "expo": "^55.0.3",
    "expo-build-properties": "~55.0.9",
    "expo-dev-client": "~55.0.9",
    "expo-document-picker": "~55.0.8",
    "expo-image": "~55.0.5",
    "expo-image-picker": "~55.0.9",
    "expo-notifications": "~55.0.22",
    "expo-sharing": "~55.0.10",
    "expo-status-bar": "~55.0.4",
    "expo-system-ui": "~55.0.9",
    "expo-updates": "~55.0.11",
    "expo-video": "~55.0.9",
    "expo-video-thumbnails": "~55.0.9",
    "firebase": "^11.0.1",
    "i18next": "^25.5.2",
    "react": "19.2.0",
    "react-datepicker": "^8.7.0",
    "react-dom": "19.2.0",
    "react-hook-form": "^7.62.0",
    "react-i18next": "^15.7.3",
    "react-native": "0.83.2",
    "react-native-gesture-handler": "~2.30.0",
    "react-native-get-random-values": "~1.11.0",
    "react-native-gifted-chat": "^3.3.2",
    "react-native-keyboard-aware-scroll-view": "^0.9.5",
    "react-native-keyboard-controller": "1.20.7",
    "react-native-paper": "^5.15.0",
    "react-native-paper-dates": "0.23.4",
    "react-native-reanimated": "4.2.1",
    "react-native-safe-area-context": "~5.6.2",
    "react-native-screens": "~4.23.0",
    "react-native-web": "^0.21.2",
    "react-native-worklets": "0.7.2",
    "react-redux": "^9.2.0",
    "redux-logger": "^3.0.6",
    "redux-persist": "^6.0.0",
    "uuid": "^13.0.0",
    "zod": "^4.1.11"
  },
  "devDependencies": {
    "@babel/plugin-syntax-jsx": "^7.27.1",
    "@babel/preset-react": "^7.27.1",
    "@types/react": "~19.2.10",
    "@types/redux-logger": "^3.0.13",
    "@typescript-eslint/eslint-plugin": "^8.54.0",
    "@typescript-eslint/parser": "^8.54.0",
    "eslint": "^9.39.2",
    "eslint-config-expo": "~55.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "prettier": "^3.8.1",
    "react-native-version": "^4.0.0",
    "typescript": "~5.9.2"
  },
  "private": true
}
